import { Plus, Trash2 } from 'lucide-react'
import { Button } from '../ui/Button'
import { TextInput } from './TextInput'

interface Field {
  key: string
  label: string
  multiline?: boolean
  rows?: number
}

interface ObjectArrayInputProps {
  label: string
  values: Record<string, string>[]
  onChange: (values: Record<string, string>[]) => void
  fields: Field[]
  emptyTemplate: Record<string, string>
}

export function ObjectArrayInput({
  label,
  values,
  onChange,
  fields,
  emptyTemplate,
}: ObjectArrayInputProps) {
  const handleAdd = () => {
    onChange([...values, { ...emptyTemplate }])
  }

  const handleRemove = (index: number) => {
    onChange(values.filter((_, i) => i !== index))
  }

  const handleChange = (index: number, key: string, value: string) => {
    const newValues = [...values]
    newValues[index] = { ...newValues[index], [key]: value }
    onChange(newValues)
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-700">{label}</label>
        <Button onClick={handleAdd} variant="secondary" size="sm">
          <Plus className="h-3 w-3" />
          Add {label.replace(/s$/, '')}
        </Button>
      </div>
      <div className="space-y-4">
        {values.map((item, index) => (
          <div key={index} className="p-4 border border-gray-200 rounded-lg space-y-3 bg-gray-50">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-600">Item {index + 1}</span>
              <button
                onClick={() => handleRemove(index)}
                className="px-2 py-1 text-red-600 hover:bg-red-50 rounded transition-colors"
                type="button"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
            {fields.map((field) => (
              <TextInput
                key={field.key}
                label={field.label}
                value={item[field.key] || ''}
                onChange={(value) => handleChange(index, field.key, value)}
                multiline={field.multiline}
                rows={field.rows}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
